/**
 * The Keycloak Account Console page where a user changes their own password (CZNA-1592).
 *
 * CZNA has no password form of its own: the password belongs to Keycloak, so My profile
 * sends the user to the console of the tenant's realm, straight to "Signing in".
 * `referrer` + `referrer_uri` make the console render a "Back to <client name>" link to
 * `returnUri`; Keycloak shows it only when `referrer_uri` matches one of the login
 * client's redirect URIs.
 *
 * Returns null when stripes does not know where Keycloak is or which login client the
 * user came through — there is then no console to send anyone to.
 */
export var buildChangePasswordUrl = function (stripes, returnUri) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var authnUrl = (_b = (_a = stripes.okapi) === null || _a === void 0 ? void 0 : _a.authnUrl) === null || _b === void 0 ? void 0 : _b.replace(/\/+$/, "");
    var tenant = (_c = stripes.okapi) === null || _c === void 0 ? void 0 : _c.tenant;
    var clientId = (_e = (_d = stripes.okapi) === null || _d === void 0 ? void 0 : _d.clientId) !== null && _e !== void 0 ? _e : (tenant ? (_h = (_g = (_f = stripes.config) === null || _f === void 0 ? void 0 : _f.tenantOptions) === null || _g === void 0 ? void 0 : _g[tenant]) === null || _h === void 0 ? void 0 : _h.clientId : undefined);
    if (!authnUrl || !tenant || !clientId) {
        return null;
    }
    var query = new URLSearchParams({
        referrer: clientId,
        referrer_uri: returnUri,
    });
    return "".concat(authnUrl, "/realms/").concat(encodeURIComponent(tenant), "/account/account-security/signing-in?").concat(query.toString());
};
